module.exports = __webpack_public_path__ + "img/dashboard-o.d43dd506.svg";